import React from "react";
import loadable from "@loadable/component";
import Loading from "../Loading.js";

const LoadableComponent = loadable(() => import("./DocumentUpload"), {
  fallback: <Loading />
});

const LoadableDocumentUpload = () => (
  <LoadableComponent />
)

export default LoadableDocumentUpload;
